"use strict";
exports.__esModule = true;
exports.TableRow = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var class_names_1 = tslib_1.__importDefault(require("../../utils/helpers/class-names"));
var table_row_style_1 = require("./table-row.style");
var TableRow = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.hasBorder, hasBorder = _b === void 0 ? true : _b, _c = _a.color, color = _c === void 0 ? 'inherit' : _c, _d = _a.backgroundColor, backgroundColor = _d === void 0 ? 'inherit' : _d, rest = tslib_1.__rest(_a, ["children", "className", "hasBorder", "color", "backgroundColor"]);
    return (react_1["default"].createElement("tr", tslib_1.__assign({ className: (0, class_names_1["default"])(hasBorder ? 'border-b border-grey-100' : "", "group", table_row_style_1.COLORS[color], table_row_style_1.BG_COLORS[backgroundColor], className) }, rest), children));
};
exports.TableRow = TableRow;
exports["default"] = exports.TableRow;
//# sourceMappingURL=table-row.js.map